import { render, staticRenderFns } from "./MySelector.vue?vue&type=template&id=11bf0974&scoped=true&"
import script from "./MySelector.vue?vue&type=script&lang=js&"
export * from "./MySelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11bf0974",
  null
  
)

export default component.exports